/** Ministry contact details — one place, used everywhere static. The
 *  editable copies live in the CMS `contact` block (lib/content.ts); these
 *  are the code defaults it starts from. */

export const ORG_NAME = "Connect Sydney";
export const TAGLINE = "Jesus | People | Campus";
export const EMAIL = "connectsydneyministry@gmail.com";
export const INSTAGRAM_URL = "https://www.instagram.com/connect_sydney";
export const INSTAGRAM_HANDLE = "@connect_sydney";
export const FACEBOOK_URL = "https://www.facebook.com/connectsydney";
export const FACEBOOK_HANDLE = "Connect Sydney";
